import { t } from "@lingui/macro";
import { ErrorMessage } from "@reactive-resume/utils";

// export const translateError = (error: ErrorMessage) => {
//   switch (error) {
//     case ErrorMessage.DisactivatedAccount: {
//       return t` It looks like your account has been deactivated. Please contact support if you believe this is a mistake.`;
//     }
//     case ErrorMessage.InvalidCredentials: {
//       return t`It doesn't look like a user exists with the credentials you provided.`;
//     }
//     case ErrorMessage.UserAlreadyExists: {
//       return t`A user with this email address already exists.`;
//     }
//     case ErrorMessage.SecretsNotFound: {
//       return t`User does not have an associated 'secrets' record. Please report this issue on GitHub.`;
//     }
//     case ErrorMessage.OAuthUser: {
//       return t`This email address is associated with an OAuth account. Please sign in with your OAuth provider.`;
//     }
//     case ErrorMessage.InvalidResetToken: {
//       return t`It looks like the reset token you provided is invalid. Please try restarting the password reset process again.`;
//     }
//     case ErrorMessage.InvalidVerificationToken: {
//       return t`It looks like the verification token you provided is invalid. Please try restarting the verification process again.`;
//     }
//     case ErrorMessage.EmailAlreadyVerified: {
//       return t`It looks like your email address has already been verified.`;
//     }
//     case ErrorMessage.TwoFactorNotEnabled: {
//       return t`Two-factor authentication is not enabled for this account.`;
//     }
//     case ErrorMessage.TwoFactorAlreadyEnabled: {
//       return t`Two-factor authentication is already enabled for this account.`;
//     }
//     case ErrorMessage.InvalidTwoFactorCode: {
//       return t`It looks like the two-factor authentication code you provided is invalid. Please try again.`;
//     }
//     case ErrorMessage.InvalidTwoFactorBackupCode: {
//       return t`It looks like the backup code you provided is invalid or used. Please try again.`;
//     }
//     case ErrorMessage.InvalidBrowserConnection: {
//       return t`There was an error connecting to the browser. Please make sure 'chrome' is running and reachable.`;
//     }
//     case ErrorMessage.ResumeSlugAlreadyExists: {
//       return t`A resume with this slug already exists, please pick a different unique identifier.`;
//     }
//     case ErrorMessage.ResumeNotFound: {
//       return t`It looks like the resume you're looking for doesn't exist.`;
//     }
//     case ErrorMessage.ResumeLocked: {
//       return t`The resume you want to update is locked, please unlock if you wish to make any changes to it.`;
//     }
//     case ErrorMessage.ResumePrinterError: {
//       return t`Something went wrong while printing your resume. Please try again later or raise an issue on GitHub.`;
//     }
//     case ErrorMessage.ResumePreviewError: {
//       return t`Something went wrong while grabbing a preview your resume. Please try again later or raise an issue on GitHub.`;
//     }
//     case ErrorMessage.SomethingWentWrong: {
//       return t`Something went wrong while processing your request. Please try again later or raise an issue on GitHub.`;
//     }

//     case ErrorMessage.CreditBalanceNotSufficient: {
//       return t`Your credit balance is insufficient to complete this operation. Please top up your account.`;
//     }
//     case ErrorMessage.MinimalAmountWithdrawal: {
//       return t`The withdrawal amount does not meet the minimum required threshold.`;
//     }
//     case ErrorMessage.NoIdempotencyKeyForPayment: {
//       return t`Missing idempotency key for payment. Please try again`;
//     }
//     case ErrorMessage.InvalidResumeLanguage: {
//       return t`The selected resume language is invalid or not supported.`;
//     }
//     case ErrorMessage.ItemNotFoundError: {
//       return t`The requested item could not be found.`;
//     }
//     case ErrorMessage.AdminAuthorizationError: {
//       return t`You do not have the required permissions to perform this action.`;
//     }
//     case ErrorMessage.PromoTypeWithoutPromoUserError: {
//       return t`This promotion type requires an associated promo ambassador`;
//     }
//     case ErrorMessage.ReductionTypeWithoutRateError: {
//       return t`This reduction type requires an associated rate.`;
//     }
//     case ErrorMessage.InvalidCoupon: {
//       return t`The coupon you provided is invalid or expired.`;
//     }
//     case ErrorMessage.InvalidPromoUser: {
//       return t`The ambassador associated with this request is invalid.`;
//     }
//     case ErrorMessage.RateAlreadyExists: {
//       return t`A rate with the same configuration already exists.`;
//     }
//     case ErrorMessage.RequiredResumeAndJobDesc: {
//       return t`Both resume and job description are required to perform this action.`;
//     }
//     case ErrorMessage.UnaivablePaymentProvider: {
//       return t`The selected payment provider is currently unavailable. Please try another method.`;
//     }

//     default: {
//       return null;
//     }
//   }
// };

export const translateError = (error: ErrorMessage) => {
  switch (error) {
    case ErrorMessage.DisactivatedAccount: {
      return t`Votre compte est désactivé. Contactez le support si nécessaire.`;
    }
    case ErrorMessage.InvalidCredentials: {
      return t`Identifiants incorrects. Veuillez réessayer.`;
    }
    case ErrorMessage.UserAlreadyExists: {
      return t`Un compte existe déjà avec cet email.`;
    }
    case ErrorMessage.SecretsNotFound: {
      return t`Une erreur interne est survenue. Merci de contacter le support.`;
    }
    case ErrorMessage.OAuthUser: {
      return t`Connectez-vous avec votre fournisseur (Google, etc.).`;
    }
    case ErrorMessage.InvalidResetToken: {
      return t`Lien de réinitialisation invalide ou expiré.`;
    }
    case ErrorMessage.InvalidVerificationToken: {
      return t`Lien de vérification invalide ou expiré.`;
    }
    case ErrorMessage.EmailAlreadyVerified: {
      return t`Votre email est déjà vérifié.`;
    }
    case ErrorMessage.TwoFactorNotEnabled: {
      return t`La double authentification n'est pas activée.`;
    }
    case ErrorMessage.TwoFactorAlreadyEnabled: {
      return t`La double authentification est déjà active.`;
    }
    case ErrorMessage.InvalidTwoFactorCode: {
      return t`Code invalide. Réessayez.`;
    }
    case ErrorMessage.InvalidTwoFactorBackupCode: {
      return t`Code de secours invalide ou déjà utilisé.`;
    }
    case ErrorMessage.InvalidBrowserConnection: {
      return t`Impossible de se connecter au navigateur. Vérifiez Chrome.`;
    }
    case ErrorMessage.ResumeSlugAlreadyExists: {
      return t`Cet identifiant de CV est déjà utilisé.`;
    }
    case ErrorMessage.ResumeNotFound: {
      return t`CV introuvable.`;
    }
    case ErrorMessage.ResumeLocked: {
      return t`Ce CV est verrouillé. Déverrouillez-le pour modifier.`;
    }
    case ErrorMessage.ResumePrinterError: {
      return t`Impossible de générer le PDF (.pdf) pour le moment.`;
    }
    case ErrorMessage.ResumePreviewError: {
      return t`Impossible d'afficher l'aperçu du CV.`;
    }
    case ErrorMessage.SomethingWentWrong: {
      return t`Une erreur est survenue. Réessayez plus tard.`;
    }

    case ErrorMessage.CreditBalanceNotSufficient: {
      return t`Crédits insuffisants. Rechargez votre compte.`;
    }
    case ErrorMessage.MinimalAmountWithdrawal: {
      return t`Montant trop faible pour un retrait.`;
    }
    case ErrorMessage.NoIdempotencyKeyForPayment: {
      return t`Erreur de paiement. Veuillez réessayer.`;
    }
    case ErrorMessage.InvalidResumeLanguage: {
      return t`Langue de tranduction du CV requise ou non supportée.`;
    }
    case ErrorMessage.ItemNotFoundError: {
      return t`Élément introuvable.`;
    }
    case ErrorMessage.AdminAuthorizationError: {
      return t`Accès refusé.`;
    }
    case ErrorMessage.PromoTypeWithoutPromoUserError: {
      return t`Promotion invalide.`;
    }
    case ErrorMessage.ReductionTypeWithoutRateError: {
      return t`Réduction invalide.`;
    }
    case ErrorMessage.InvalidCoupon: {
      return t`Coupon invalide ou expiré.`;
    }
    case ErrorMessage.InvalidPromoUser: {
      return t`Utilisateur promo invalide.`;
    }
    case ErrorMessage.RateAlreadyExists: {
      return t`Ce tarif existe déjà.`;
    }
    case ErrorMessage.RequiredResumeAndJobDesc: {
      return t`CV et offre requis pour effectuer cette operation`;
    }
    case ErrorMessage.UnaivablePaymentProvider: {
      return t`Moyen de paiement indisponible. ressayez plus tard`;
    }
    case ErrorMessage.DecisonWithdrawalHasAlreadyMade: {
      return t`La desicion finale concernant ce retrait a deja été prise`;
    }
    default: {
      return null;
    }
  }
};
